/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Mode_Dual_KeyInputs */



/**
* | output |
* | --- |
* | "Dual Key" |
*
* @param {Timing_Sync_Mode_Dual_KeyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_mode_dual_key = /** @type {((inputs?: Timing_Sync_Mode_Dual_KeyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Mode_Dual_KeyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Double touche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dual-Key")
	if (locale === "it") return /** @type {LocalizedString} */ ("Doppia chiave")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Двойной ключ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Doble llave")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("双钥匙")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デュアルキー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डुअल की")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Chave dupla")
	return /** @type {LocalizedString} */ ("Dual Key")
});